import { takeLatest } from 'redux-saga/effects';
import { OnCallRequesterTypes } from '~/domain/interfaces/redux/onCallRequester/types';
import { onList, onListSuccess, onListFailed } from './List';

const tasks = [
  takeLatest(OnCallRequesterTypes.LIST, onList),
  takeLatest(OnCallRequesterTypes.LIST_SUCCESS, onListSuccess),
  takeLatest(OnCallRequesterTypes.LIST_FAILED, onListFailed),
];

export default tasks;
